import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrNotificationClient } from '../../../../../../shared/types/modules/pqr';
import { PqrNotificationClientProps } from './props';
import { asyncGetAccount } from '../../../../../../services/accounts.service';
import { useNavigate } from 'react-router-dom';
import { PQR } from '../../../../../../routes/paths';

export const usePqrNotificationClient = ({
    data,
    onChangeData,
    onChangeFormik,
    idAccount,
}: PqrNotificationClientProps) => {
    const navigate = useNavigate();
    const onSubmit = (data: PqrNotificationClient) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('email', data?.email || formik.values.email);
        formik?.setFieldValue('phone', data?.phone || formik.values.phone);
    }, [data]);

    useEffect(() => {
        if (Boolean(idAccount?.trim()))
            asyncGetAccount(idAccount || '').then((data) => {
                if (!data || !data.id || !data.email) navigate(PQR);
                formik?.setFieldValue('email', data?.email || '');
                formik?.setFieldValue('phone', data?.cellPhone || '');
            });
    }, []);

    return {
        formik,
    };
};
